import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkCloseTutorial } from "../../../features/mobile/otherSlice";

const Tutorial = ({ setTutorialState }) => {
    const { loginInfo } = useSelector((state) => state.commonApp);
  const { questionsCompleteCheck } = useSelector((state) => state.others);
  const navigate = useNavigate();

  // const [status, setStatus] = useState(1);
  const dispatch = useDispatch();

  // useEffect(() => {
  //       dispatch(checkCloseTutorial(loginInfo.userId));
  // }, [status, dispatch, loginInfo.userId, navigate]);

  // const onChangeExplain = (e) => {
  //   if (e.target.checked) dispatch(checkCloseTutorial(loginInfo.userId));
  // };
  const onCloseGuide = async () => {
    try {
      const res = await dispatch(checkCloseTutorial(loginInfo.userId)).unwrap();

      if (res) {
        setTutorialState(false);
        window.location.reload();
      } else {
        console.log("Failed to close guide");
      }
    } catch (error) {
      console.error("Error closing guide:", error);
    }
  };

  return (
    <div className="h-auto w-full rounded-tl-[28px] bg-back_ground px-[11px] pb-[100px] ">
      <div className="flex flex-col pt-[30px]">
        {/* <div className="fixed z-10 flex items-center mx-auto text-white maxW bottom-24 right-4 text-body1_600 gap-x-2">
        <span>Don't show this again</span>
        <input
          type="checkbox"
          className="tutorial"
          onChange={onChangeExplain}
        />
      </div> */}

        {/* Meal Record */}
        <div className="py-2.5">
          <div className="flex flex-row px-2.5 overflow-hidden max-h-[180px] mb-2.5">
            <div className=" flex w-[180px] flex-col items-start gap-2">
              <p className="text-xl font-bold text-black">{"Meal Log"}</p>
              <span className="text-[15px] font-medium leading-[18px] text-neutral-500">
                {"Track what you eat and manage your health!"}
              </span>
              <button
                className="w-[107px] justify-center gap-2.5 rounded-3xl bg-main p-2.5"
                onClick={() => {
                  if (questionsCompleteCheck?.healthComplete) {
                    navigate("/meal/record");
                  } else {
                    navigate("/question/health");
                  }
                }}
              >
                <span className="text-base font-semibold leading-[18px] tracking-tight text-white">
                  {"Log"}
                </span>
              </button>
            </div>
            <div className="flex items-end justify-center max-w-[180px] h-[180px] overflow-hidden">
              <img
                src="/images/mobile/home/guide_meal.svg"
                alt="meal record guide"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 items-start gap-2.5 pb-2.5">
            {/* Weight Record */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => {
                if (questionsCompleteCheck?.healthComplete) {
                  navigate("/weight/record");
                } else {
                  navigate("/question/health");
                }
              }}
            >
              <div className="flex h-[218px] w-full flex-col items-start overflow-hidden rounded-xl border bg-white px-4 py-2.5">
                <div className="flex flex-col items-start w-full gap-2">
                  <div className="text-xl font-bold text-black">{"Weight Tracking"}</div>

                  <div className="text-sm font-medium text-neutral-500">
                    {"Track your current weight"}
                  </div>
                  <div className="flex items-end justify-center w-full h-[120px] overflow-hidden">
                    <img
                      src="/images/mobile/home/guide_weight.svg"
                      alt="weight record guide"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Symptom Record */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => {
                if (questionsCompleteCheck?.healthComplete) {
                  navigate("/symptom/record");
                } else {
                  navigate("/question/health");
                }
              }}
            >
              <div className="flex h-[218px]  w-full flex-col items-start overflow-hidden rounded-xl border bg-white px-4 py-2.5">
                <div className="flex flex-col items-start w-full gap-2">
                  <div className="text-xl font-bold text-black">{"Symptom Tracking"}</div>

                  <div className="text-sm font-medium text-neutral-500">
                    {"Any symptoms to report?"}
                  </div>
                  <div className="flex items-end justify-center w-full h-[120px] overflow-hidden">
                    <img
                      src="/images/mobile/home/guide_symptom.svg"
                      alt="symptom record guide"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 items-start gap-2.5 pb-5">
            {/* Steps */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => navigate("/step")}
            >
              <div className="flex h-[218px] w-full flex-col items-start justify-between overflow-hidden rounded-xl border bg-white">
                <div className="flex flex-col items-start gap-2 px-4 py-2.5">
                  <div className="text-xl font-bold text-black">{"Steps"}</div>
                  <div className="text-sm font-medium text-neutral-500">
                    {"How many steps today?"}
                  </div>
                </div>
                <div className="flex items-end justify-center w-full h-[130px] px-4 pb-2 overflow-hidden">
                  <img
                    src="/images/mobile/home/guide_step.svg"
                    alt="steps guide"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
            {/* Medication Reminder */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => navigate("/drugalarm")}
            >
              <div className="flex h-[218px] w-full flex-col items-start justify-between overflow-hidden rounded-xl border bg-white">
                <div className="flex flex-col items-start gap-2 px-4 py-2.5">
                  <div className="text-xl font-bold text-black">{"Medication Reminder"}</div>

                  <div className="text-sm font-medium text-neutral-500">
                    {"Never miss your medication"}
                  </div>
                </div>

                <div className="flex items-end justify-center w-full h-[130px] px-4 pb-2 overflow-hidden">
                  <img
                    src="/images/mobile/home/guide_drug.svg"
                    alt="medication reminder guide"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="pt-[10px]" onClick={() => navigate("/treatment")}>
            <div className="flex h-[109px] shrink-0 flex-row items-center justify-between gap-2.5 overflow-hidden rounded-xl border bg-white px-4 py-2">
              <div className="flex items-end justify-center flex-1 h-full overflow-hidden">
                <img
                  src="/images/mobile/home/guide_treatment.svg"
                  alt="appointment reminder guide"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex flex-col items-end gap-2 text-end flex-1">
                <p className="text-xl font-semibold text-black">
                  {"Appointment Reminder"}
                </p>
                <span className="text-[15px] font-medium leading-[18px] text-neutral-500">
                  {"Track appointments and get reminders"}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center w-full pt-4">
          <button
            className="flex h-[38px] items-center justify-center rounded-lg border border-main bg-white px-4 py-2"
            onClick={() => onCloseGuide()}
          >
            <span className="text-base font-medium leading-[18px] tracking-tight text-main">
              {"Close Guide"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
